<template>
  <div class="comp">
    <MenuMovilTP />
    <main class="container mb-4 d-block d-lg-block dkt">
      <Titulo titulo="COMPARADOR CARRERAS" subTitulo="TÉCNICO PROFESIONALES" />
      <FormComparador
        @comparar="comparar"
        @limpiarComparacion="limpiarComparacion"
      />
    </main>

    <main
      class="container px-0 collapse show"
      style="font-weight: 400; font-size: 14px"
    >
      <b-container fluid>
        <Comparacion
          v-if="mostrarComparacion"
          :carrera1="comparacion[0]"
          :carrera2="comparacion[1]"
        />
      </b-container>
    </main>
    <MenuMovilUni />
  </div>
</template>

<script>
import MenuMovilTP from "@/components/generales/menuMovil/TecnicoProfesional";
import MenuMovilUni from "@/components/generales/menuMovil/AdmisionUniversitaria";
import Titulo from "@/components/generales/paginas/TituloPagina";
import FormComparador from "@/components/comparadorITP/FormComparador";
import Comparacion from "@/components/comparadorITP/Comparacion";
import ApiComparadorTP from "@/services/ApiComparadorTP";

export default {
  name: "ComparadoITP",
  components: {
    MenuMovilTP,
    MenuMovilUni,
    Titulo,
    FormComparador,
    Comparacion
  },
  data() {
    return {
      mostrarComparacion: false,
      comparacion: []
    };
  },
  methods: {
    async comparar(selecciones) {
      this.$emit("cargar");
      for (let seleccion of selecciones) {
        let resultado = await ApiComparadorTP.getCarreraGenericaInfo(seleccion);
        if (resultado) {
          this.comparacion.push(resultado);
        }
      }
      if (this.comparacion.length === 2) {
        this.mostrarComparacion = !this.mostrarComparacion;
      }
      this.$emit("cargado");
    },
    limpiarComparacion() {
      this.$emit("cargar");
      this.comparacion = [];
      this.mostrarComparacion = !this.mostrarComparacion;
      this.$emit("cargado");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/BuscadoresTP/ComparadorITP.vue